<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="auto">
        <v-row align="center" class="fill-height text-capitalize" justify="center">
          <b>{{ fromLabel }}</b>
        </v-row>
      </v-col>
      <v-item-group :value="innerValue"
                    @change="emitValue($event)"
                    class="mx-3"
      >
        <v-row align="center" class="fill-height flex-nowrap" justify="center">
          <v-col
              :key="item"
              cols="auto"
              v-for="(item) in valueList"
          >
            <v-item :value="item" v-slot:default="{ active, toggle }">
              <v-hover>
                <template v-slot="{ hover }">
                  <v-card
                      :color="active ? 'primary' : ''"
                      :elevation="hover ? 24 : ''"
                      @click="toggle"
                      class="d-flex align-center"
                      height="50"
                      light
                      width="50"
                      :style="{'box-shadow': active ? '0 0 0 1px white !important' : '0 0 0 0px white !important'}"
                  >
                    <v-card-text :style="{ 'color': active ? 'white' : 'black' }"
                                 class="flex-grow-1 text-center"
                    ><b>{{ $t_num(item) }}</b>
                    </v-card-text>
                  </v-card>
                </template>
              </v-hover>
            </v-item>
          </v-col>
        </v-row>
      </v-item-group>
      <v-col cols="auto">
        <v-row align="center" class="fill-height text-capitalize" justify="center">
          <b>{{ toLabel }}</b>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    export default {
        name: "CogDiff",
        props: {
            fromValue: {
                type: Number,
                default: 1
            },
            toValue: {
                type: Number,
                default: 7
            },
            fromLabel: {
                type: String,
                default: 'Always'
            },
            toLabel: {
                type: String,
                default: 'Never'
            },
            value: {
                required: true
            }
        },
        computed: {
            valueList() {
                let list = [];
                for (let i = 0; i < this.toValue; i++) {
                    list.push(i + 1);
                }
                return list.slice(this.fromValue - 1, this.toValue);
            }
        },
        data: () => ({
            innerValue: null,
        }),
        methods: {
            cloneInner() {
                this.innerValue = this.value;
            },
            emitValue(event) {
                this.innerValue = event;
                if (this.innerValue !== this.value) {
                    this.$emit('input', this.innerValue);
                }
            }
        },
        mounted() {
            this.cloneInner();
        },
        watch: {
            value() {
                this.cloneInner();
            }
        }
    }
</script>

<style scoped>

</style>